<template>
    <div :class="['container', { 'container-dark': theme_dark }]">
  
      <div class="nav-top">
            <div class="nav-left" @click="back()">
              <img src="../assets/img/返回箭头.png" class="nav-img" />
              <span class="nav-lable"></span>
            </div>
            <div class="nav-middle">打招呼</div>
            <div class="nav-right">
              <span class="nav-lable" @click="hello_sys()">招呼设置</span>
              <img src="../assets/img/返回箭头.png" class="nav-img none" />
            </div>
      </div>
  
      <ul class="recommend-section">
       <li class="user-card" v-for="(item, index) in arr_10" :key="index">
         <div class="user-info">
           <div class="avatar">
             <img v-if="item.photo" :src="item.photo" alt="" />
             <div class="online-tag ub ub-pc">
                <div class="tips-state tag-state1" v-if="item.dtm_sp <= (60 * 30)"></div>
                <div class="tips-state tag-state2" v-if="item.dtm_sp > (60 * 30) && item.dtm_sp <= (3600 * 3)"></div>
                <div class="tips-state tag-state3" v-if="item.dtm_sp > (3600 * 3)"></div>
  
                <div class="details-state">
                    <span class="state1" v-if="item.dtm_sp < 60">刚刚</span>
                    <span class="state2" v-if="item.dtm_sp >= 60 && item.dtm_sp < 3600">{{ Math.floor(item.dtm_sp / 60) }}分钟</span>
                    <span class="state3" v-if="item.dtm_sp >= 3600">{{ Math.floor(item.dtm_sp / 3600) }}小时</span>
                </div>
              </div>
           </div>
           <div class="details">
             <div class="information1 ub ub-pc">
              <span>{{ item.nick.length > 5 ? item.nick.substr(0,4) + '...' : item.nick }}</span>
              <div class="age-range">
               <img v-if="item.sex == '男生'" src="../assets/img/男.png" alt="#"/>
               <img v-if="item.sex == '女生'" src="../assets/img/女.png" alt="#"/>
               <span>{{ item.age_range }}</span>
              </div>
  
             </div>
             <div class="information2 ub">
                  <div class="crad-value ub ub-ac ub-pc">
                    <span>豪气值 {{ item.coin_total }}</span>
                  </div>
                  <div class="crad-value ub ub-ac ub-pc">
                    <span>魅力值 {{ item.score_total }}</span>
                  </div>
             </div>
             
             <div class="tips ub">
                <div class="tag" v-for="(tag, index) in item.arr_tag" :key="index">#{{ tag }}</div>
              </div>
           </div>
         </div>
  
         <div class="ub ub-ver ub-pc">
            <button class="btn btn_chat ub ub-ac ub-pc" v-if="item.btn_state == 1" @click="send_msg(item)">打招呼</button>
            <button class="btn btn_chat1 ub ub-ac ub-pc" v-if="item.btn_state == 11" @click="goto_chat(item.uid)">已打招呼</button>
            <button class="btn btn_chat1 ub ub-ac ub-pc" v-if="item.btn_state == 2" @click="goto_chat(item.uid)">继续聊天</button>
            <button class="btn btn_chat ub ub-ac ub-pc" v-if="item.btn_state == 3" @click="goto_chat(item.uid)">去回复</button>
         </div>
  
         
       </li>
  
       <div class="ub ub-pc ub-ac"  v-if="arr_10.length < arr_all.length && userinfo.vip_level < 1">
         <div class="ub ub-ac ub-pe btn-more" @click="load_more()">查看更多(会员特权)</div>
       </div>
      
      </ul>
      <dlg ref="myForm_buyVip" @formBehavior="formact_buyVip"></dlg>
      <dlg ref="myForm_hello" @formBehavior="formact_hello"></dlg>
      <hello_sys ref="hello_sys" @SetSuccess="set_success"></hello_sys>
      <alert ref="myConfirm_buyCoin" @userBehavior="formact_buycoin"></alert>
    </div>
  </template>
  <script>
  import * as tool from "../api/common";
  import { mapMutations, mapActions } from "vuex";
  import Form from "../components/Form.vue";
  import Alert from "../components/Alert.vue";
  import HelloSys from "../components/Hello_Sys.vue";
  export default {
    components: {
      dlg: Form,
      alert: Alert,
      hello_sys: HelloSys
    },
  
    data() {
      return {
        userinfo: {
            vip_level: 0,
            chat_mny_score: 0,
            coin_left: 0,
            sex: ""
        },
        theme_dark: false,
        arr_10: [],
        arr_all: [],
        chat_count: 0,
        size: 10,
        timeout: 30,
        arr_hello: [],
        chat_countMax: 10,
        to_info: {}
      };
    },
    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.$loading("正在加载中...");
      var self = this;
      setTimeout(() => {
        self.$loading.close();
       }, 5000);
      this.init_page();
      this.init_list();
      this.init_hello_list();
    },
    methods: {
      ...mapMutations(["get", "post"]), //引入方法
      ...mapActions(["act_get_userinfo","act_sub_coin"]), //引入方法
  
      back() {
        this.$router.go(-1); //返回上一层
      },
  
      init_page() {
  
        var uid = this.$store.state.uid;
        if (uid) {
          this.init_user(uid);
        }
  
        var loc_data = localStorage.getItem('loc_earn_score');
        if (loc_data) {
          loc_data = JSON.parse(loc_data);
          var dtm_now = new Date().getTime();
          var dtm = loc_data.dtm;
          var timeDiff = (dtm_now - dtm ) / 1000; //相差时间
          timeDiff = Math.floor(timeDiff);
          if (timeDiff >= 30) {
            this.timeout = 0;
          } else {
            this.timeout = 30 - timeDiff;
          }
        } else {
          this.timeout = 0;
        }
        
        var clock = window.setInterval(() => {
            this.timeout--;
            if (this.timeout <= 0) {
              window.clearInterval(clock);
            }
        }, 1000);
  
      },
  
      init_list() {
        if (this.timeout <= 0) {
          this.get_serveData();
        } else {
          var loc_data = localStorage.getItem('loc_earn_score');
          if (loc_data) {
            this.$loading.close();
            loc_data = JSON.parse(loc_data);
            var data = loc_data.data_serve;
            this.format_data(data);
          }
        }
      },
  
      //初始化打招呼数据
      init_hello_list() {
        var say_hello = this.$store.state.http_cache.say_hello;
        if (say_hello.data_serve.length > 0) {
          this.arr_hello = say_hello.data_serve;
          return true;
        }
  
        var self = this;
        self.get({
            url:"/App/GetCnfig_SayHelloMsg",
            success: function(data) {
              var obj = {
                dtm: new Date().getTime(),
                data_serve: data.boy
              }
              self.$store.commit("set_http_cache", {say_hello: obj});
              self.arr_hello = data.boy;
            },
            error: function(res) {}
        });
      },
  
      get_serveData() {
        var uid = this.$store.state.uid;
        var self = this;
  
        self.get({
          url: "/App/Get_User_CanCoin?uid=" + uid,
          success: function(data) {
            self.$loading.close();
            var obj = {
              dtm: new Date().getTime(),
              data_serve: data
            };
            localStorage.setItem('loc_earn_score', JSON.stringify(obj));
  
            var filteredData = JSON.parse(JSON.stringify(data));
            self.format_data(filteredData);
            self.timeout = 30;
          },
          error: function(res) {}
        });
      },
  
  
      init_user(uid) {
        var self = this;
        self.act_get_userinfo({
          uid: uid,
          success: function (u) {
            self.userinfo.vip_level = u.vip_level;
            self.userinfo.chat_mny_score = u.chat_mny_score;
            self.userinfo.coin_left = u.coin_left;
            self.userinfo.sex = u.sex;
          },
        });
      },
  
      //整理数据
      format_data(list_data) {
        // 获取当天的消息
        var messages = this.$store.state.message;
  
        //处理数据
        for (var i = 0; i < list_data.length; i++) {
          var user = list_data[i];
          //初始化数据
          user.photo = this.$store.state.url + "/photo/" + user.photo;
          user.create_time = user.create_time.replace(/-/g, "/");
          user.create_time = new Date(user.create_time);
          user.newuser = tool.dateDiff_Now(user.create_time) <= (60 * 60 * 24);
          user.to_msgNum = 0;
          user.self_msgNum = 0;
          user.sum_msgNum = 0;
          user.client_deep = 0;
          user.last_msg_tag = "";
          user.talked = false;
          user.arr_tag = user.inst_tag.split('|');
          // 格式化在线用户数据
          user.least_time = user.least_time.replace(/-/g, "/");
          user.least_time = new Date(user.least_time);
          var second = tool.dateDiff_Now(user.least_time);
          user.dtm_sp = second;
          
          // 找到当前用户相关的聊天记录
          var chat = messages.find(chat => user.uid === chat.to);
          if (chat) {
            var txts = chat.txts;
  
            var sum_info = this.get_sumInfo(txts);
  
            // 更新用户信息
            user.talked = true; // 是否聊过
            user.to_msgNum = sum_info.to_msgNum; // 对方消息数
            user.self_msgNum = sum_info.self_msgNum; // 自己消息数
            user.sum_msgNum = sum_info.to_msgNum + sum_info.self_msgNum; // 总消息数
            user.client_deep = sum_info.deep; // 深度
            user.last_msg_tag = sum_info.last_msg_tag;
          }
  
          this.format_state(user);
        }

        //过滤我拉黑的人
        var my_complain = this.$store.state.my_complain;
        list_data = list_data.filter(
            item2 => !my_complain.some(item1 => item1.uid == item2.uid)
        );
        //过滤拉黑我的人
        var complain_my = this.$store.state.complain_my;
        list_data = list_data.filter(
            item2 => !complain_my.some(item1 => item1.uid === item2.uid)
        );
  
        //保存数据
        this.arr_all = list_data;
        this.arr_10 = this.arr_all.slice(0, this.size);
      },
  
      format_state (user) {
          // 处理提示话术
          var tip = "";
          var btn_state = 0;
          // 按钮状态1=打招呼，11=已打招呼，2=继续聊天，3=去回复，4=翻倍奖励
          if (user.sum_msgNum < 1) {
            btn_state = 1;
            tip = "跟他打个招呼吧，聊天有积分哦";
          }
          if (user.to_msgNum < 1 && user.self_msgNum >= 1) {
            btn_state = 11;
            tip = "已打招呼，等待对方回复~";
          }
          if (user.sum_msgNum > 1) {
            btn_state = 2;
            tip = "继续跟他聊天，马上获得聊天积分";
          }
          if (user.last_msg_tag == "to" && user.sum_msgNum >= 1) {
            btn_state = 3;
            tip = "回复领取积分，马上回复~";
          }
          user.tip = tip;
          user.btn_state = btn_state;
      },
  
  
      //加载更多
      load_more() {
        if (this.checkVip("此功能是会员特权功能，成为会员即刻获得更多用户~")) {
          this.arr_10 = this.arr_all;
        }
      },
  
      checkVip(msg) {
        var b = true;
        var vip_level = this.userinfo.vip_level;
        if (vip_level == 0) {
          //购买会员提示
          this.$refs.myForm_buyVip.show(msg, {
            type: "confirm",
            confirmText: "升级会员",
            titleText: "温馨提示",
            data: ""
          });
          return false;
        }
        return b;
      },
  
      formact_buyVip(type, data) {
        if (type == "clickConfirm") {
          this.$router.push({ name: "vip_center" });
        }
      },
  
      // 招呼设置
      hello_sys() {
        this.$refs.hello_sys.show("设置");
      },
  
      set_success() {
        this.send_msg(this.to_info);
      },
      
      //聊天
      send_msg(item) {
        this.to_info = item;
        var is_set_sayHello = this.$store.state.objVal.is_set_sayHello;
        if (!is_set_sayHello) {
          this.$refs.hello_sys.show();
          return false;
        }
  
        if (item.nocoin == 1) {
          this.send_hello(item.uid);
          var user = this.arr_all.find(user => item.uid === user.uid);
          user.btn_state = 11;
          user.tip = "已打招呼，等待对方回复~";
          return true;
        }
  
        //聊天满10次后需要会员权限或支付金币
        
        if (this.chat_count >= this.chat_countMax) {
          if (this.is_vip_hello("此功能是会员特权功能，成为会员可无限次数打招呼，或者支付100金币也可以跟ta打招呼哦~",item.uid)) {
            var to_uid = item.uid;
            this.send_hello(to_uid);
            var user = this.arr_all.find(user => item.uid === user.uid);
            user.btn_state = 11;
            user.tip = "已打招呼，等待对方回复~";
          }
          return true;
        }
        var to_uid = item.uid;
        this.send_hello(to_uid);
        var user = this.arr_all.find(user => item.uid === user.uid);
        user.btn_state = 11;
        user.tip = "已打招呼，等待对方回复~";
  
      },
  
      send_hello(to_uid) {
        var msg_info = this.get_hello_txt();
        var msg = {
          to: to_uid,
          msg_type: msg_info.msg_type,
          msg_txt: msg_info.txt
        };
        this.send(msg);
      },
  
      send: function (msg) {
        //发送消息
        var send_msg = { to: msg.to, type: msg.msg_type, txt: msg.msg_txt };
        this.$socket.emit("send_one", send_msg);
        //整理消息，本地store中保存
        send_msg.dtm = new Date().Format("yyyy/MM/dd hh:mm:ss");
        this.$store.commit("push_message", send_msg);
        this.$store.commit("set_msg_count");
        this.$toast.center("已发送打招呼");
        tool.set_user_hello("", this.userinfo, this.to_info, false);
      },
  
      is_vip_hello(msg,uid_to) {
        var b = true;
        var vip_level = this.userinfo.vip_level;
        if (vip_level == 0) {
          //购买会员提示
          this.$refs.myForm_hello.show(msg, {
            type: "confirm",
            confirmText: "升级会员",
            cancelText: "支付金币",
            titleText: "温馨提示",
            data: uid_to
          });
          return false;
        }
        return b;
      },
  
      formact_hello(type, data) {
        if (type == "clickConfirm") {
          this.$router.push({ name: "vip_center" });
        }
        if (type == "clickCancel") {
            var uid = this.$store.state.uid;
            var coin = 100;
            
            //判断剩余金币
            if (this.userinfo.coin_left < coin) {
              this.$refs.myConfirm_buyCoin.show("金币余额不足,请先充值哦", {
                type: "confirm",
                confirmText: "充值",
                titleText: "温馨提示",
                data: "",
              });
              return false;
            } 
            var data = {
              "uid": uid,
              "coin": coin,
              "uid_to": data
            };
            this.sub_coin_relieve(data);
        }
      },
  
      //扣除金币
      sub_coin_relieve(data) {
        var send_data = {
          "uid_from": data.uid,
          "uid_to": "",
          "amount": data.coin,
          "type_dtl": "打招呼",
          "comment": "",
        };
        var self = this;
         self.act_sub_coin({
           uid: data.uid,
           strSend: JSON.stringify(send_data),
           success: function (res) {
             if (res.state == "1") {
              var to_uid = data.uid_to;
              self.send_hello(to_uid);
              var user = self.arr_all.find(user => to_uid === user.uid);
              user.btn_state = 11;
              user.tip = "已打招呼，等待对方回复~";
             }
           },
         });
        },
  
        formact_buycoin(type, data) {
          if (type == "clickConfirm") {
            this.$router.push({ name: "mycoin" });
          }
        },
  
      //继续
      goto_chat(to_uid) {
        this.$router.push({ name: "chart", params: { uid: to_uid } });
      },
  
      get_sumInfo(txts) {
        var obj = {
          "to_msgNum": 0,
          "self_msgNum": 0,
          "deep":0,
          "last_msg_tag": ""
        }
        var count_tag = true;
          for (var i = 0; i < txts.length; i++) {
            var item = txts[i];
            if (item.tag === "to") {
              obj.to_msgNum++;
            }
            if(item.tag == 'to' && count_tag == true) {
              obj.deep++;
              count_tag = false;
            }
            if(item.tag == 'self') {
              count_tag = true;
              obj.self_msgNum++;
            }
            obj.last_msg_tag = item.tag;
          }
          return obj;
      },
  
      get_hello_txt() {
        var txt = {};
        
        var loc_hello = JSON.parse(localStorage.getItem("loc_customize_hello")) || [];
        if (loc_hello.length > 0) {
            var hello_info = loc_hello.filter(item => item.on == true);
            if (hello_info[0].type == "custom") {
              txt = {
                msg_type: "text",
                txt: hello_info[0].txt
              }
            }
            if (hello_info[0].type == "sys") {
              txt = this.arr_hello[Math.floor(Math.random() * this.arr_hello.length)];
            }
        } else {
          txt = this.arr_hello[Math.floor(Math.random() * this.arr_hello.length)];
        }
        return txt;
    }
  
    },
  };
  </script>
  <style lang="scss" scoped>
  .container {
    min-height: 100vh;
    background-color: #EFEFEF;
    background-size: 100% 100%;
  
    .nav-top {
      background-color: #8A61FF;
    }
    .nav-right {
      padding-right: 0.5rem;
      .nav-lable {
        margin: 0;
        font-size: 0.9rem;
        color: #fff;
      }
    }
  }
  
  .tips-block {
    padding: 0.5rem 0.8rem;
    .refresh-btn {
        width: 100%;
        height: 4rem;
        border-radius: 1rem;
        background-color: #59e064;
        span {
            font-size: 1rem;
            font-weight: bold;
            color: #FFFFFF;
        }
    }
    
  }
  .tip {
      margin-bottom: 0.5rem;
        span {
            font-size: 0.7rem;
            color: #fff;
        }
    }
  
  .recommend-section {
    flex: 1;
    overflow-y: auto;
    scrollbar-width: none; /* firefox 不显示滚动条 */
    -ms-overflow-style: none; /* IE 10+ 不显示滚动条 */
    padding: 0.5rem;
    background: linear-gradient(to bottom,#8A61FF, #FE9CC0, #fff 50rem);
    
  }
  
  .recommend-section::-webkit-scrollbar {
    display: none; /* Chrome Safari 不显示滚动条 */
  }
  
  .recommend-section > li:last-of-type {
      position: relative;
  }
  
  .btn-more {
      position: absolute;
      padding-bottom: 1rem;
      margin-bottom: 12rem;
      width: 100%;
      height: 15rem;
      background: linear-gradient(to bottom, #ffffff36, #fff 12rem);
      font-size: 0.9rem;
      color: rgb(186, 97, 255);
    }
  
  .user-card {
      height: 5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #FDFDFD;
      padding: 1rem 0.4rem;
      border-bottom: 1px solid #dcdcdc;
      .user-info {
        display: flex;
        align-items: center;
        color: #333;
        font-weight: bold;
        .avatar {
          margin-right: 0.62rem;
          img {
            margin-top: 0.5rem;
            width: 3.5rem;
            height: 3.5rem;
            border-radius: 50%;
          }
          
        }
        .online-tag {
            .tips-state {
              margin-top: 0.1rem;
              width: 0.5rem;
              height: 0.5rem;
              border-radius: 50%;
            }
            .tag-state1 {
              background-color: #2AE459;
            }
            .tag-state2 {
              background: orange;
            }
            .tag-state3 {
              background: #888;
            }
          }
          .details-state {
          margin-left: 0.2rem;
            span {
              font-size: 0.65rem;
            }
             .state1 {
              color: #2AE459;
             }
            .state2 {
              color: rgba(52,199,89,0.6);
            }
            .state3 {
              color: rgba(52,199,89,0.3);
            }
          }
        
      }
      
      .btn {
        width: 4.1rem;
        padding: 0.5rem 0;
        border: none;
      }
      
      .btn_chat {
      border-radius: 2rem;
      background-image: linear-gradient(to bottom,#8A61FF,#FE9CC0);
      color: #FFFFFF;
      font-size: 0.65rem;
      font-weight: bold;
    }
    .btn_chat1 {
      border-radius: 2rem;
      background-color: #E9E9E9;
      color: #898989;
      font-size: 0.65rem;
      font-weight: bold;
    }

  
      .tips {
        .tag {
          margin-right: 0.3rem;
          font-size: 0.75rem;
          color: rgb(186, 97, 255);
        }
      }
    }
  
  .user-card:nth-child(1) {
    border-top-left-radius: 0.6rem;
    border-top-right-radius: 0.6rem;
  }
  
  .details {
          height: 5rem;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
            .information1 {
              .age-range {
                padding:1px 2px;
                border: 1px solid #999;
                border-radius: 3px;
                font-size: 0.7rem;
                margin-left: 0.5rem;
                display: flex;
                justify-content:space-evenly;
                align-items: center;
                img {
                  width: 0.8rem;
                  height: 0.8rem;
                }
                span {
                  font-size: 0.6rem;
                }
              }
              .avoid_coin {
                margin-left: 0.5rem;
                padding: 1px 2px;
                border-radius: 3px;
                background-color: #2cac32;
                span {
                  font-size: 0.6rem;
                  color: #fff;
                }
              }
              span{
                font-size: 0.9rem;
              }
              
            }
            .information2 {
              flex-wrap: wrap;
              .crad-value {
                margin-right: 0.5rem;
                padding:1px 2px;
                border-radius:3px;
                border:1px solid #dcdcdc;
                span {
                  font-size: 0.6rem;
                }
              }
              .tag {
                margin-right: 0.3rem;
                padding: 1px 2px;
                border-radius: 3px;
              .tag-vip {
                border: 1px solid red;
                span {
                    font-size: 0.6rem;
                    color: red;
                }
              }
              .tag-new{
                border: 1px solid #08c908;
                span {
                    font-size: 0.6rem;
                    color: #08c908;
                }
              }
              .tag-fill{
                border: 1px solid #fdcf00;
                span {
                    font-size: 0.6rem;
                    color: #fdcf00;
                }
              }
            }
            }
  }
  
  .container-dark {
    min-height: 100vh;
    background-color: #1a191c;
    .nav-top {
      background-color: #3c296e;
    }
  
    .recommend-section {
      background: linear-gradient(to bottom,#3c296e, #5f3b48, #2F2E33 50rem);
      .btn-more {
        background: linear-gradient(to bottom, #3532323d, #2c2b30 12rem);
      }
    }
  
    .user-card {
        background-color: #2c2b30;
        border-bottom: 1px solid #666;
        .user-info {
          color: #fff;
        }
        .btn_talked {
          span {
            color: #FDFDFD;
          }
        }
      }
  }
  </style>
  